<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">GOBSECK</a></li>
<li><span href="#/Text/Section0004" title="Link target outside of Sample">At the Sign of the Cat and Racket</span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3c2bcb30